export default function ({ req }) {
  let cachedData = [];
  const updatedListeners = [];
  const errorListeners = [];

  return {
    refresh: () => {
      req
        .findList()
        .then((organisations) => {
          cachedData = organisations;
          updatedListeners.forEach((listener) => listener(cachedData));
        })
        .catch((error) => {
          errorListeners.forEach((listener) => listener(error));
        });
    },
    data: () => cachedData,
    onUpdated: (callback) => {
      updatedListeners.push(callback);
    },
    onError: (callback) => {
      errorListeners.push(callback);
    },
  };
}
